<template>
  <a class="navbar-brand app-logo" href="#/">
    <img
      class="logo-img d-inline-block mb-1"
      :class="online ? 'bg-success' : 'bg-danger'"
      src="../assets/icons8-c-50.png"
      alt="cooksy-logo"
      width="30"
      height="24"
    />
    <span class="logo-text">ooksy</span>
  </a>
</template>

<script>
export default {
  name: "AppLogo",
  props: {
    online: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.app-logo {
  margin-top: -7px;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: var(--bs-navbar-brand-color, var(--bs-body-color));
}

.app-logo:hover,
.app-logo:focus {
  color: var(--bs-navbar-brand-hover-color, var(--bs-body-color));
}

.logo-img {
  padding: 2px;
  margin-right: -2px;
  margin-top: 8px;
}

.logo-text {
  padding-left: 4px;
}
</style>
